export const GET_TEST_ACTION: string = 'getTest' 
export const GET_ALL_TESTS_ACTION: string = 'getAllTests' 
export const GET_TEST_TRY_COUNT_ACTION: string = 'getTestTryCountUser' 
export const UPDATE_TEST_USER_RESULT_ACTION: string = 'updateTestUser' 
export const GET_TEST_USER_RESULT_ACTION: string = 'getTestUserResult'      // single user test result
export const GET_TEST_USER_RESULTS_ACTION: string = 'getTestUserResults'    // list of user's tests 
export const GET_TEST_RESULTS_USERS_ACTION: string = 'getTestResultsUsers'  // list of users
export const REMOVE_TEST_RESULT_ACTION: string = 'removeTestResult'         // list of users

